// extracted by mini-css-extract-plugin
export default {"cardForm":"Steps_cardForm__cCWme","subtitle":"Steps_subtitle__pNQWG"};